export const VERSION_STORAGE_KEY = 'tzlvt_app_version';
